// extracted by mini-css-extract-plugin
export default {"ratings-circle":"Ratings_ratings-circle__AIRlL","active":"Ratings_active__lasbP","last":"Ratings_last__XFPCc"};